export const COLORS = {
  BLUE: "BLUE",
  GREY: "GREY",
  WHITE: "WHITE",
  BLACK: "BLACK",
  SKY_BLUE: "SKY_BLUE"
};

export type Color = keyof typeof COLORS;
